export enum NoteType {
  Warning = 'warning',
  Danger = 'danger',
  Success = 'success',
}
